module.exports = __webpack_public_path__ + "img/p6.dc522fc1.webp";